import logoBlack from "../assest/images/logoBlack.png";
import dreamimg from "../assest/images/dreamimg.png";

const DreamExperienceSection = () => {
    return (
        <section className="experience">
            <div className="experienceBox">
                <div className="container">
                    <div className="dreamBox">
                        <div className="boxjourney">
                            <div className="logo-box">
                                <img src={logoBlack} alt="logoBlack" />
                            </div>
                            <div className="dreamText">
                                <h2>Build your dream <br /> experience</h2>
                                {/* <div className="showMore">
                                    <button className="btn showMoreBtn">Show more <i className="fa-solid fa-chevron-right"></i></button>
                                </div> */}
                            </div>
                        </div>
                        <div className="expImgBox">
                            <img src={dreamimg} alt="dreamimg" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default DreamExperienceSection;